import Products from 'merchandise-lib/constants/Product';
import { isValidApiName } from './typeguards';
export const SkuCategoryNameToProductLineMap = {
  MARKETING_PRODUCTS: {
    freeHighlightedProduct: 'marketing-hub-free',
    paidHighlightedProducts: [Products.MARKETING_HUB_STARTER, Products.MARKETING_HUB_PROFESSIONAL, Products.MARKETING_HUB_ENTERPRISE]
  },
  SALES_PRODUCTS: {
    freeHighlightedProduct: 'sales-hub-free',
    paidHighlightedProducts: [Products.SALES_HUB_STARTER, Products.SALES_HUB_PROFESSIONAL, Products.SALES_HUB_ENTERPRISE]
  },
  SERVICE_HUB_PRODUCTS: {
    freeHighlightedProduct: 'service-hub-free',
    paidHighlightedProducts: [Products.SERVICE_HUB_STARTER, Products.SERVICE_HUB_PROFESSIONAL, Products.SERVICE_HUB_ENTERPRISE]
  },
  CMS_HUB_PRODUCTS: {
    freeHighlightedProduct: 'cms-hub-free',
    paidHighlightedProducts: [Products.CMS_HUB_STARTER, Products.CMS_HUB_PROFESSIONAL, Products.CMS_HUB_ENTERPRISE]
  },
  OPERATIONS_HUB_PRODUCTS: {
    freeHighlightedProduct: 'operations-hub-free',
    paidHighlightedProducts: [Products.OPERATIONS_HUB_STARTER, Products.OPERATIONS_HUB_PROFESSIONAL, Products.OPERATIONS_HUB_ENTERPRISE]
  }
};
export const FREE_PRODUCTS = ['marketing-hub-free', 'service-hub-free',
// @ts-expect-error - operations-hub-free is not a valid ProductApiName value yet
'operations-hub-free', 'cms-hub-free',
// @ts-expect-error - sales-hub-free is not a valid ProductApiName value yet
'sales-hub-free', 'hubspot-free'];
export const getHighlightedProductsForSkuCategory = ({
  skuCategoryName
}) => {
  var _productsMetadata$pai;
  const productsMetadata = SkuCategoryNameToProductLineMap[skuCategoryName];
  const paidHighlightedProducts = productsMetadata === null || productsMetadata === void 0 || (_productsMetadata$pai = productsMetadata.paidHighlightedProducts) === null || _productsMetadata$pai === void 0 ? void 0 : _productsMetadata$pai.filter(isValidApiName);

  // @ts-expect-error - sales-hub-free and operations-hub-free are not valid ProductApiName values yet
  const freeHighlightedProduct = productsMetadata === null || productsMetadata === void 0 ? void 0 : productsMetadata.freeHighlightedProduct;
  return {
    paidHighlightedProducts,
    freeHighlightedProduct
  };
};